import React from "react";
import { FormattedMessage } from "react-intl"

const anchorUrlMainFi = "https://tukes.fi/asiointi/rekisterit-ja-patevyydet/toimintaoikeuksien-selitteet"
const anchorUrlMainSv = "https://tukes.fi/sv/e-tjanster/register/forklaringarna-for-verksamhetsrattigheter"

const anchorUrlOperatingRightsFi = "https://tukes.fi/asiointi/rekisterit-ja-patevyydet/toimintaoikeuksien-selitteet#toiminnanharjoittajarekisterin-toimintaoikeuskoodit"
const anchorUrlOperatingRightsSv = "https://tukes.fi/sv/e-tjanster/register/forklaringarna-for-verksamhetsrattigheter#verksamhetsrattigheter"

const anchorUrlRefrigerationQualificationsFi = "https://tukes.fi/asiointi/rekisterit-ja-patevyydet/toimintaoikeuksien-selitteet#kylmaalan-henkilopatevyydet"
const anchorUrlRefrigerationQualificationsSv = "https://tukes.fi/sv/e-tjanster/register/forklaringarna-for-verksamhetsrattigheter#personbehorigheterna-inom-kylbranchen"

const anchorUrlSprayTesterQualificationsFi = "https://tukes.fi/asiointi/rekisterit-ja-patevyydet/toimintaoikeuksien-selitteet#ruiskuntestaajan-henkilopatevyydet"
const anchorUrlSprayTesterQualificationsSv = "https://tukes.fi/sv/e-tjanster/register/forklaringarna-for-verksamhetsrattigheter#personbehorigheterna-sprut-testare"

const anchorUrlPestControlOperatorsFi = "https://tukes.fi/kemikaalit/biosidit/tuholaistorjunta"
const anchorUrlPestControlOperatorsSv = "https://tukes.fi/sv/kemikalier/biocider/skadedjursbekampning"

const anchorUrlPestControlCompetencyRegistryFi = "https://tukes.fi/kemikaalit/biosidit/tuholaistorjunta"
const anchorUrlPestControlCompetencyRegistrySv = "https://tukes.fi/sv/kemikalier/biocider/skadedjursbekampning"



const getAnchorUrl = (location, locale) => {
    return (locale === "sv") ? getAnchorUrlSv(location) : getAnchorUrlFi(location)
}

const getAnchorUrlFi = location => {
    return ({
        "/": anchorUrlMainFi,
        "/toiminnanharjoittajat": anchorUrlOperatingRightsFi,
        "/kylma-alan-patevyys": anchorUrlRefrigerationQualificationsFi,
        "/ruiskuntestaajan-patevyys": anchorUrlSprayTesterQualificationsFi,
        "/tuholaistorjunnan-toiminnanharjoittajat": anchorUrlPestControlOperatorsFi,
        "/tuholaistorjunnan-patevyys": anchorUrlPestControlCompetencyRegistryFi
    })[location]
}

const getAnchorUrlSv = location => {
    return  ({
            "/": anchorUrlMainSv,
            "/toiminnanharjoittajat": anchorUrlOperatingRightsSv,
            "/kylma-alan-patevyys": anchorUrlRefrigerationQualificationsSv,
            "/ruiskuntestaajan-patevyys": anchorUrlSprayTesterQualificationsSv,
            "/tuholaistorjunnan-toiminnanharjoittajat": anchorUrlPestControlOperatorsSv,
            "/tuholaistorjunnan-patevyys": anchorUrlPestControlCompetencyRegistrySv
        })[location]
}

const knownLocations = [
  "/",
  "/toiminnanharjoittajat",
  "/kylma-alan-patevyys",
  "/ruiskuntestaajan-patevyys",
  "/tuholaistorjunnan-toiminnanharjoittajat",
  "/tuholaistorjunnan-patevyys",
  "/nimileimat",
  "/kuntaleimat",
];

const getCompetencyExplanationKey = location => {
    // Note: IE does not support includes
    location = knownLocations.indexOf(location) !== -1 ? location : "/"
    return ({
        "/": "common.competencyExplanations.frontPage",
        "/toiminnanharjoittajat": "common.competencyExplanations.operator",
        "/kylma-alan-patevyys": "common.competencyExplanations.refrigeration",
        "/ruiskuntestaajan-patevyys": "common.competencyExplanations.sprayTester",
        "/tuholaistorjunnan-toiminnanharjoittajat": "common.competencyExplanations.pestControl",
        "/tuholaistorjunnan-patevyys": "common.competencyExplanations.pestControl"
    })[location]
}

export const CompetencyDescriptions = props => {
    const locale = props.locale || "fi"
    const location = props.location.pathname || "/"
    
    return (
        <FormattedMessage
            id={getCompetencyExplanationKey(location)}
            values={{
                explanationUrl: (
                    <a
                        href={getAnchorUrl(location, locale)}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <FormattedMessage id="common.competencyAnchorText" />
                    </a>
                )
            }}
        />
    )
}


// WEBPACK FOOTER //
// ./src/components/CompetencyDescriptions.js